import { Modal } from 'react-responsive-modal';
import { Form, FormContainer, FormWrapper } from './components';
import { StyledInput } from '../../../../components/StyledInput';
import { StyledSelect } from '../../../UserVehicles/components/StyledSelect';
import { useCallback, useState } from 'react';
import { UF } from '../../../../utils/enums';
import './modal.scss';

export interface IGlobalFiltersModalProps {
  open: boolean;
  setOpen: (item: boolean) => void;
}

export default function AdvancedFiltersModal({ open, setOpen }: IGlobalFiltersModalProps) {
  const [plateOrConductor, setPlateOrConductor] = useState<string | undefined>(undefined)
  const [uf, setUf] = useState('');

  const handleChangePlate = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPlateOrConductor(e.target.value.toUpperCase());
    },
    [setPlateOrConductor],
  );


  function handleSubmit() {

  }
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      showCloseIcon={false}
      center
    >
      <div className='advanced-filters-modal-body'>
        <span className='title'>Filtros Avançados</span>

        <FormContainer>
          <Form onSubmit={handleSubmit}>
            <FormWrapper>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledInput
                  style={{ gridColumn: 'span 2' }}
                  placeholder="Digite a placa ou o condutor"
                  value={plateOrConductor}
                  maxLength={7}
                  onChange={handleChangePlate}
                  required
                  disabled={false}
                  labelTxt='Placa ou Condutor'
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='UF'
                  placeholder="Selecione a UF"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Tipo de Débito'
                  placeholder="Selecione o débito"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="">
                <StyledSelect
                  labelTxt='Vencimento'
                  placeholder="Data de início"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ marginTop: "20px" }}>
                <StyledSelect
                  placeholder="Data de fim"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Parcela IPVA'
                  placeholder="Selecione a parcela"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Final de Placa'
                  placeholder="Selecione"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
              <label htmlFor="" style={{ gridColumn: "span 2" }}>
                <StyledSelect
                  labelTxt='Status'
                  placeholder="Selecione o status"
                  value={uf}
                  setValue={setUf}
                  options={Object.keys(UF).map((key) => ({
                    id: key,
                    value: UF[key as keyof typeof UF],
                  }))}
                />
              </label>
            </FormWrapper>
          </Form>
        </FormContainer>

        <span className='clean-form'>Limpar todos os filtros</span>

        <div className='actions-buttons'>
          <button
            className='cancel'
            onClick={() => setOpen(false)}
          >
            Voltar
          </button>
          <button
            className='save'
            onClick={() => {
              setOpen(false)
            }}
          >
            Aplicar
          </button>
        </div>
      </div>
    </Modal>
  )
}